import React from 'react';
import {UrlFixer} from "../../../utils/utils";
import {DateDisplay} from "../../Extra/DateDisplay";
import {useNavigate} from "react-router-dom";

export const NewsItemSidebarOtherNewsThumb = ({other}) => {

    const navigate = useNavigate();

    function clickHandler(newsItemId, slug) {
        let url = '/news/' + newsItemId + '/' + slug;
        navigate(url);
    }

    return (
        <div className="side-widget">
            <h5>More News</h5>
            <ul className="other-news-list">
                {other.map((item, index) => {
                    return <li key={index} onClick={(e) => clickHandler(item.id, item.slug)}>
                        <img src={UrlFixer(item.image_details.variations.sidebar_thumb)} alt={item.title}/>
                        <strong>{item.title}</strong>
                        <span className="pdate"><i className="fas fa-calendar-alt"></i> <DateDisplay
                            datetime={item.published_at}/></span>
                    </li>;
                })}
            </ul>
        </div>
    )
}
